$(document).ready(function() {

    $("video").prop('muted', true);
/*
    if( $("video").prop('muted') ) {
          $("video").prop('muted', true);
    } else {
      $("video").prop('muted', true);
    }
*/
});


$(document).ready(function () {

    $(function () {
        $("#test").click(function () {
            $("#logo-test").addClass("logo-test");
        });
    });

    $(function () {
        $(".audio").click(function () {
            $("video").prop('muted', false);
        });
    });

    // PREGUNTA 1
    $("input[name=pregunta1]").click(function () {
        $("input[name=pregunta1]").attr("disabled", true);
        //console.log;
    });
    $(function () {
        $("#p1a").click(function () {
            $(this).addClass("correcto");
            $("#p1b, #p1c, #p1d").addClass("disable");
            $(".bt-sig").addClass("show");
            $(".p1c").addClass("respuesta");
            $("#p1a, #p1b, #p1c, #p1d").css({
                "pointer-events": "none"
            });
            $("#p1a, #p1b, #p1c, #p1d").click(function () {
                return false;
            });
           // console.log;
        });
        $("#p1b, #p1c, #p1d").click(function () {
            $(this).addClass("incorrecto");
            $("#p1a, #p1b, #p1c, #p1d").addClass("disable");
            $(this).removeClass("disable");
            $(".bt-sig").addClass("show");
            $(".p1e").addClass("respuesta");
            $("#p1a, #p1b, #p1c, #p1d").css({
                "pointer-events": "none"
            });
            $("#p1a, #p1b, #p1c, #p1d").click(function () {
                return false;
            });
           // console.log;
        });
        $(".bt-sig").click(function () {
            $(".bt-sig").removeClass("show");
           // console.log;
        });

    });

    // PREGUNTA 2
    $("input[name=pregunta2]").click(function () {
        $("input[name=pregunta2]").attr("disabled", true);
       // console.log;
    });
    $(function () {
        $("#p2c").click(function () {
            $(this).addClass("correcto");
            $("#p2a, #p2b, #p2d").addClass("disable");
            $(".bt-sig").addClass("show");
            $(".p2c").addClass("respuesta");
            $("#p2a, #p2b, #p2c, #p2d").css({
                "pointer-events": "none"
            });
            $("#p1a, #p1b, #p1c, #p1d").click(function () {
                return false;
            });
            //console.log;
        });
        $("#p2a, #p2b, #p2d").click(function () {
            $(this).addClass("incorrecto");
            $("#p2a, #p2b, #p2c, #p2d").addClass("disable");
            $(this).removeClass("disable");
            $(".bt-sig").addClass("show");
            $(".p2e").addClass("respuesta");
            $("#p2a, #p2b, #p2c, #p2d").css({
                "pointer-events": "none"
            });
            $("#p2a, #p2b, #p2c, #p2d").click(function () {
                return false;
            });
            //console.log;
        });
        $(".bt-sig").click(function () {
            $(".bt-sig").removeClass("show");
           // console.log;
        });
    });

    // PREGUNTA 3
    $("input[name=pregunta3]").click(function () {
        $("input[name=pregunta3]").attr("disabled", true);
        //console.log;
    });
    $(function () {
        $("#p3c").click(function () {
            $(this).addClass("correcto");
            $("#p3a, #p3b, #p3d").addClass("disable");
            $(".bt-sig").addClass("show");
            $(".p3c").addClass("respuesta");
            $("#p3a, #p3b, #p3c, #p3d").css({
                "pointer-events": "none"
            });
           //console.log;
        });
        $("#p3a, #p3b, #p3d").click(function () {
            $(this).addClass("incorrecto");
            $("#p3a, #p3b, #p3c, #p3d").addClass("disable");
            $(this).removeClass("disable");
            $(".bt-sig").addClass("show");
            $(".p3e").addClass("respuesta");
            $("#p3a, #p3b, #p3c, #p3d").css({
                "pointer-events": "none"
            });
            //console.log;
        });
        $(".bt-sig").click(function () {
            $(".bt-sig").removeClass("show");
            //console.log;
        });
    });

    // PREGUNTA 4
    $("input[name=pregunta4]").click(function () {
        $("input[name=pregunta4]").attr("disabled", true);
        //console.log;
    });
    $(function () {
        $("#p4c").click(function () {
            $(this).addClass("correcto");
            $("#p4a, #p4b, #p4d").addClass("disable");
            $(".bt-sig").addClass("show");
            $(".p4c").addClass("respuesta");
            $("#p4a, #p4b, #p4c, #p4d").css({
                "pointer-events": "none"
            });
            //console.log;
        });
        $("#p4a, #p4b, #p4d").click(function () {
            $(this).addClass("incorrecto");
            $("#p4a, #p4b, #p4c, #p4d").addClass("disable");
            $(this).removeClass("disable");
            $(".bt-sig").addClass("show");
            $(".p4e").addClass("respuesta");
            $("#p4a, #p4b, #p4c, #p4d").css({
                "pointer-events": "none"
            });
            //console.log;
        });
        $(".bt-sig").click(function () {
            $(".bt-sig").removeClass("show");
            //console.log;
        });
    });

    // PREGUNTA 5
    $("input[name=pregunta5]").click(function () {
        $("input[name=pregunta5]").attr("disabled", true);
        //console.log;
    });
    $(function () {
        $("#p5a").click(function () {
            $(this).addClass("correcto");
            $("#p5b, #p5c, #p5d").addClass("disable");
            $(".bt-sig").addClass("show");
            $(".p5c").addClass("respuesta");
            $("#p5a, #p5b, #p5c, #p5d").css({
                "pointer-events": "none"
            });
            //console.log;
        });
        $("#p5b, #p5c, #p5d").click(function () {
            $(this).addClass("incorrecto");
            $("#p5a, #p5b, #p5c, #p5d").addClass("disable");
            $(this).removeClass("disable");
            $(".bt-sig").addClass("show");
            $(".p5e").addClass("respuesta");
            $("#p5a, #p5b, #p5c, #p5d").css({
                "pointer-events": "none"
            });
            //console.log;
        });
        $(".bt-sig").click(function () {
            $(".bt-sig").removeClass("show");
           //console.log;
        });
    });

    $(".bt-sig").click(function () {
        var p1;
        if ($('#p11').is(':checked')) {
             p1 = 1
        } else {
             p1 = 0
        }
        var p2;
        if ($('#p23').is(':checked')) {
             p2 = 1
        } else {
             p2 = 0
        }
        var p3;
        if ($('#p33').is(':checked')) {
             p3 = 1
        } else {
             p3 = 0
        }
        var p4;
        if ($('#p43').is(':checked')) {
             p4 = 1
        } else {
             p4 = 0
        }
        var p5;
        if ($('#p51').is(':checked')) {
             p5 = 1
        } else {
             p5 = 0
        }

        var resultado = p1 + p2 + p3 + p4 + p5;

        if (resultado == 0) {
            $("#r1").addClass("rfinal");
        }
        if (resultado >= 1) {
            $("#r2").addClass("rfinal");
            $("#r1").removeClass("rfinal");
        }
        if (resultado >= 3) {
            $("#r3").addClass("rfinal");
            $("#r1, #r2").removeClass("rfinal");
        }
        if (resultado == 5) {
            $("#r4").addClass("rfinal");
            $("#r1, #r2, #r3").removeClass("rfinal");
        }

        console.log(resultado);

    });

    $("#nav_test, .btn_participa, .necesitas").click(function () {

        var resultado = 0;

        $("#p1a, #p1b, #p1c, #p1d, .bt-sig, .p1c, .p1e").removeClass('correcto incorrecto disable respuesta show');
        $("#p1a, #p1b, #p1c, #p1d").css({
            "pointer-events": "auto"
        });
        $("input[name=pregunta1]").removeAttr("disabled checked")

        $("#p2a, #p2b, #p2c, #p2d, .bt-sig, .p2c, .p2e").removeClass('correcto incorrecto disable respuesta show');
        $("#p2a, #p2b, #p2c, #p2d").css({
            "pointer-events": "auto"
        });
        $("input[name=pregunta2]").removeAttr("disabled checked")

        $("#p3a, #p3b, #p3c, #p3d, .bt-sig, .p3c, .p3e").removeClass('correcto incorrecto disable respuesta show');
        $("#p3a, #p3b, #p3c, #p3d").css({
            "pointer-events": "auto"
        });
        $("input[name=pregunta3]").removeAttr("disabled checked")

        $("#p4a, #p4b, #p4c, #p4d, .bt-sig, .p4c, .p4e").removeClass('correcto incorrecto disable respuesta show');
        $("#p4a, #p4b, #p4c, #p4d").css({
            "pointer-events": "auto"
        });
        $("input[name=pregunta4]").removeAttr("disabled checked")

        $("#p5a, #p5b, #p5c, #p5d, .bt-sig, .p5c, .p5e").removeClass('correcto incorrecto disable respuesta show');
        $("#p5a, #p5b, #p5c, #p5d").css({
            "pointer-events": "auto"
        });
        $("input[name=pregunta5]").removeAttr("disabled checked")

        $("#logo-test").addClass("logo-test");

        console.log(resultado);

    });

    $("#legal").click(function () {
        if (!$(this).hasClass('checked')) {
            $("#check_legal").attr('src', './img/check_mark.png');
            $(this).addClass('checked');
            $(".bt_form").removeAttr('disabled')
        } else {
            $(this).removeClass('checked');
            $("#check_legal").attr('src', './img/check.png');
            $(".bt_form").attr('disabled', true)
        }
    });

    $("#notificacion").click(function () {
        if (!$(this).hasClass('checked')) {
            $("#check_noti").attr('src', './img/check_mark.png');
            $(this).addClass('checked');
        } else {
            $(this).removeClass('checked');
            $("#check_noti").attr('src', './img/check.png');
        }
    });

    $(".enviar, #nav_tengo, #nav_kit, .necesitas, .bt-resultado").click(function () {
        $("#logo-test").removeClass("logo-test");
    });

    $("#nav_tengo, #amigo_home").click(function () {
        $("#comparte_test").hide();
        $("#comparte_no").show();
    });

    $("#nav_test, #test_home").click(function () {
        $("#comparte_test").show();
        $("#comparte_no").hide();
    });

    $('#enviar_form').click(function () {
        var validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

        $('[type="email"]').change(function emailval() {
            var isValid = this.value.match(validEmail),
                isInternet = this.value.match(/@.*\./);
            console.log(this.value, isValid, isInternet)
        });


        if (($('#nombre' && '#celular').val() == '') && ($.isFunction(emailval)) && (!$('input[name="legal"]:checked').length == 0)) {
            //$('.bt_form').prop('type', 'submit');

            //$('.bt_form').prop('type', 'button');
            //$('.bt_form').attr('href', '#site');
        } else {
            $('.bt_form').prop('type', 'button');
            $('.bt_form').attr('href', '#site');

            //$('.bt_form').prop('type', 'submit');
        }
        //console.log;
    });

    $('#documento').change(function () {
         var maxLen;
        if ($(this).val() == 'DNI') {
             maxLen = 8;

            $('#n_documento').keypress(function (event) {
                var Length = $("#n_documento").val().length;
                var AmountLeft = maxLen - Length;
                $('#txt-length-left').html(AmountLeft);
                if (Length >= maxLen) {
                    if (event.which != 8) {
                        return false;
                    }
                }
            });
        } else {
             maxLen = 12;

            $('#n_documento').keypress(function (event) {
                var Length = $("#n_documento").val().length;
                var AmountLeft = maxLen - Length;
                $('#txt-length-left').html(AmountLeft);
                if (Length >= maxLen) {
                    if (event.which != 12) {
                        return false;
                    }
                }
            });
        }
    });

    $('#celular').keypress(function (event) {

        var maxLen = 9;

        var Length = $("#celular").val().length;
        var AmountLeft = maxLen - Length;
        $('#txt-length-left').html(AmountLeft);
        if (Length >= maxLen) {
            if (event.which != 9) {
                return false;
            }
        }
    });

    $('#nav_tengo, #nav_kit, #amigo_home, #test_home, #nav_test').click(function (event) {
        $('#video_home').get(0).pause();
        $('#video_home').get(0).currentTime = 0;
    });

    $(".necesitas").click(function (event) {
        $('#video_home').get(0).play();
        //console.log;
    });

});
